import { ReactElement } from 'react';
import { SettingOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { Button } from 'common/components/antd/Button/Button';
import HeaderLayoutCounterpartyName
  from 'common/components/HeaderLayoutCounterpartyName/HeaderLayoutCounterpartyName.component';
import { StatusText } from 'common/components/StatusText/StatusText';
import {
  SContainer,
  SProperties,
  SLabel,
  SText,
  SValueSpacer,
  SProperty,
} from './Header.style';

const counterparty = {
  name: 'TEST',
  holding_name: 'TEST Systems',
  description: 'Commercial tool',
  status: 1,
}; // mock

export const HeaderComponent = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <SContainer>
      <div
        style={{
          display: 'flex',
        }}
      >
        <div>
          <Space size={16}>
            <HeaderLayoutCounterpartyName />
          </Space>
        </div>

        <SProperties>
          <SProperty
            style={{
              width: 222,
            }}
          >
            <SLabel>{t('usrRoleMng.header.description')}</SLabel>
            <SValueSpacer>
              <SText>{counterparty.description}</SText>
            </SValueSpacer>
          </SProperty>
          <SProperty
            style={{
              width: 189,
            }}
          >
            <SLabel>{t('usrRoleMng.header.holdingName')}</SLabel>
            <SValueSpacer>
              <SText>{counterparty.holding_name}</SText>
            </SValueSpacer>
          </SProperty>
          <SProperty>
            <SLabel>{t('usrRoleMng.header.status')}</SLabel>
            <SValueSpacer>
              <StatusText color="#52C41A">{t('usrRoleMng.header.status.active')}</StatusText>
            </SValueSpacer>
          </SProperty>
        </SProperties>
      </div>

      <div>
        <Button icon={<SettingOutlined />} />
      </div>
    </SContainer>
  );
};
